/**
 * Inline error / success / auxiliary messages for post create forms.
 */
import React from "react";
import { Info } from "lucide-react";

export interface FormStatusMessageProps {
  error?: string;
  success?: string;
  auxiliary?: string;
  className?: string;
}

const FormStatusMessage: React.FC<FormStatusMessageProps> = ({
  error,
  success,
  auxiliary,
  className = "",
}) => {
  if (!error && !success && !auxiliary) return null;

  return (
    <div className={`flex flex-col gap-1 ${className}`.trim()}>
      {error ? (
        <div className="flex items-center text-warning-red dark:text-warning-red-dark text-sm">
          <Info className="mr-1 shrink-0" aria-hidden />
          <span>{error}</span>
        </div>
      ) : null}
      {auxiliary ? (
        <div className="flex items-center text-warning-red dark:text-warning-red-dark text-sm">
          <Info className="mr-1 shrink-0" aria-hidden />
          <span>{auxiliary}</span>
        </div>
      ) : null}
      {success ? (
        <div className="flex items-center text-green-600 dark:text-green-500 text-sm">
          <Info className="mr-1 shrink-0" aria-hidden />
          <span>{success}</span>
        </div>
      ) : null}
    </div>
  );
};

export default FormStatusMessage;
